import { AXIOS } from "@/AXIOS/http-common";

const state = {
  organizations: [],
};

const urlPrefix = "/admin/organization";

const actions = {
  async getAllOrganizations(context, data) {
    if (data == undefined) {
      data = {
        page: 0,
        size: 20,
      };
    }
    return await AXIOS.get(
      urlPrefix + "/all?page=" + data.page + "&size=" + data.size
    ).then((response) => {
      console.log(response.data);
      context.commit("setOrganizations", response.data);
    });
  },

  async searchOrganizations(context, data) {
    return await AXIOS.get(
      urlPrefix +
        "/search?searchedSegment=" +
        data.query +
        "&page=" +
        data.page +
        "&size=" +
        data.size
    ).then((response) => {
      console.log(response.data);
      context.commit("setOrganizations", response.data);
    });
  },

  async addNewOrganization(context, data) {
    return await AXIOS.post(urlPrefix + "/create", data);
  },

  async editOrganization(context, data) {
    console.log(data);
    return await AXIOS.post(urlPrefix + "/edit", data);
  },

  async deleteOrganization(context, organizationId) {
    return await AXIOS.get(
      urlPrefix + "/delete?organizationId=" + organizationId
    );
  },
};

const mutations = {
  setOrganizations(state, data) {
    state.organizations = data;
  },
};

const getters = {
  GETORGANIZATIONS: (state) => state.organizations,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
